module.exports = __webpack_public_path__ + "f2393e743df284596149be62712e78e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/subtasks.png
// module id = 61
// module chunks = 0